<template>
  <div class="container-privacy" :style="`paddingTop:${barHeight}px`">
    <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" @click-left="closeWeb" />
      </template>
    </van-nav-bar>
    <div class="main" v-html="$t('lang.privacy.content')"></div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    let query = this.$route.query
    return {
      barHeight: query.statusBarHeight || 38
    }
  }
}
</script>
<style lang="scss" scoped>
.container-privacy {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  .main {
    padding: 0 16px 16px 16px;
    color: #666666;
    line-height: 20px;
  }
}
</style>
